import { useCallback, useEffect, useState } from "react";
import type { EmblaCarouselType } from "embla-carousel";

export function useEmblaSlidesInView(
  emblaApi: EmblaCarouselType | undefined,
): number[] {
  const [slidesInView, setSlidesInView] = useState<number[]>([]);

  const updateSlidesInView = useCallback((api: EmblaCarouselType) => {
    setSlidesInView(api.slidesInView());
  }, []);

  useEffect(() => {
    if (!emblaApi) {
      return;
    }

    const onUpdate = () => {
      updateSlidesInView(emblaApi);
    };

    updateSlidesInView(emblaApi);
    emblaApi
      .on("reInit", onUpdate)
      .on("select", onUpdate)
      .on("scroll", onUpdate);

    return () => {
      emblaApi
        .off("reInit", onUpdate)
        .off("select", onUpdate)
        .off("scroll", onUpdate);
    };
  }, [emblaApi, updateSlidesInView]);

  return slidesInView;
}
